import { Escape, IconClose16, TDeviceType } from '@cian/ui-kit';
import { clsx as cn } from 'clsx';
import * as React from 'react';

import styles from './VideoPlaybackModal.css';

interface IVideoPlaybackModalProps {
  deviceType: TDeviceType;
  isOpen: boolean;
  videoSrc: string;
  modalRef: React.RefObject<HTMLDivElement>;
  onClose: () => void;
}

export const VideoPlaybackModal: React.FC<IVideoPlaybackModalProps> = ({ deviceType, onClose, videoSrc, modalRef }) => (
  <Escape active onEscape={onClose}>
    <div role="dialog" ref={modalRef} className={styles['modal-container']}>
      <button className={styles['close-button']} aria-label="Закрыть" onClick={onClose}>
        <IconClose16 color="white_100" />
      </button>
      <div className={cn(styles['background'], styles[deviceType])} onClick={onClose} aria-hidden="true" />
      <div className={styles['modal-content']}>
        <iframe
          className={cn(styles['video-iframe'], styles[deviceType])}
          src={videoSrc}
          data-testid="video-playback-modal-iframe"
          title="Видео о том, как забронировать квартиру в новостройке на сайте партнера и получить высокое вознаграждение за проведенную сделку."
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          loading="lazy"
        />
      </div>
    </div>
  </Escape>
);
